import { gql, TypedDocumentNode } from "@apollo/client";

import { useFetchQuery } from "src/graphql/utils";
import { mapToCustomerCases } from "src/mappers/customer.mappers";
import { isEmpty } from "src/utils/arrays.utils";

import {
  GetCustomerCasesSearchQuery,
  GetCustomerCasesSearchQueryVariables,
} from "../../__generated__/graphql";
import { caseSummaryFragment } from "../../fragments/CaseSummaryFragment";
import { SearchParamsCustomerCases } from "../typings";

export const getCustomerCasesSearchQuery = gql`
  query GetCustomerCasesSearch(
    $id: ID!
    $searchString: String
    $offset: Int = 0
    $limit: Int!
    $caseTypeCode: String
  ) {
    customerCasesSearch(
      id: $id
      options: {
        searchString: $searchString
        caseTypeCode: $caseTypeCode
        pagination: { offset: $offset, limit: $limit }
      }
    ) {
      cases {
        ...CaseSummaryFragment
        alerts {
          id
        }
      }
      pageInfo {
        totalCount
        offset
        limit
      }
    }
  }
  ${caseSummaryFragment}
` as TypedDocumentNode<GetCustomerCasesSearchQuery, GetCustomerCasesSearchQueryVariables>;

export const useGetCustomerCasesQuery = ({
  searchTerm,
  offset,
  limit,
  id,
  caseTypeCode,
}: SearchParamsCustomerCases) => {
  return useFetchQuery(getCustomerCasesSearchQuery, {
    toData: (data) =>
      data?.customerCasesSearch && {
        cases: data.customerCasesSearch.cases.map(mapToCustomerCases),
        pageInfo: data.customerCasesSearch.pageInfo,
      },
    isEmpty: (data) => isEmpty(data?.customerCasesSearch.cases),
    queryOptions: {
      variables: {
        id: id || "",
        limit: limit,
        offset: offset,
        searchString: searchTerm && searchTerm.length > 0 ? searchTerm : null,
        caseTypeCode: caseTypeCode || null,
      },
    },
    uiErrors: {
      fetchError: "FETCH-CUSTOMER-CASES-ERROR",
    },
  });
};
